import type { Event } from '@mb/types';

export const getDateFormatted = (event: Event | null, userLang: string) => {
  if (userLang === 'en' && ENVIRONMENT_REGION === 'EU') {
    userLang = 'uk';
  }
  if (!event) return '';

  const startDate = new Date(Date.parse(event.start_date.replace(/-/g, '/')));
  const startDateString = startDate.toLocaleDateString(userLang);
  const startTimeString = startDate.toLocaleTimeString(userLang, {
    hour: '2-digit',
    minute: '2-digit',
  });
  let dateFormatted = `${startDateString} - ${startTimeString}`;
  if (event?.end_date) {
    const endDate = new Date(Date.parse(event.end_date.replace(/-/g, '/')));
    const endDateString = endDate.toLocaleDateString(userLang);
    const endTimeString = endDate.toLocaleTimeString(userLang, {
      hour: '2-digit',
      minute: '2-digit',
    });

    if (startDateString === endDateString) {
      dateFormatted = `${startDateString} ${startTimeString} - ${endTimeString}`;
    } else {
      dateFormatted = `${startDateString} - ${endDateString}`;
    }
  }
  return dateFormatted;
};
